export default __webpack_public_path__ + "static/media/office_4.0111a099.jpeg";